import { FC } from 'react'
import { twMerge } from 'tailwind-merge'
import { Toast, Props as ToastProps } from './Toast'

export const Banner: FC<ToastProps> = ({ className, ...props }) => {
  return (
    <Toast
      className={twMerge('w-full rounded-none', className)}
      shadow={false}
      {...props}
    />
  )
}
